import { NAME } from './constants';
import { router } from './router';

export const NastaveniTisku = {
	name: NAME,
	router,
};
